import Api from 'atomic-fuel/libs/middleware/api';

// This file just exports the default global api. If modifications are needed
// make the modifications in this file by extending the Api or copy pasting the
// code into this file.
export default Api;
